import { createSlice } from '@reduxjs/toolkit';

import { type ILocation } from '@/microfrontends/filters/shared/types/location';

export type TRegionsState = ILocation[];

const regionsInitialState: TRegionsState = [];

export const regionsSlice = createSlice({
  initialState: regionsInitialState,
  name: 'regions',
  reducers: {},
});

export const { reducer: regionsReducer, actions: regionsActions } = regionsSlice;
